<script>
    let reloading = false;
    import LoadingAnim from "./LoadingAnim.svelte";

</script>

<div class="overlay">
    <div class="bg">
        {#if !reloading}
            <p>
                <img
                    class="offlineLogo"
                    src="./images/logo_offline.svg"
                    alt=""
                />
                אין אינטרנט
            </p>
            <button
                class:reloading
                on:click={() => {
                    reloading = true;
                    location.reload();
                    console.log('reload');
                }}
            >
                רענון
            </button>
        {:else}
            <div class="loadingAnim">
                <LoadingAnim color={'var(--blue1)'} />
            </div>
        {/if}
    </div>
</div>

<style>
    .reloading {
        background: gray;
    }

    .loadingAnim {
        transform: translate(4px, 5px) scale(0.8);
    }

    .overlay {
        z-index: 9999;
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #3b3b3b;
    }

    .bg {
        font-family: sans-serif;
        background: white;
        border-radius: 4px;
        width: 100%;
        max-width: 310px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        font-size: 22px;
        font-weight: 500;
        padding: 10px;
        direction: rtl;
        box-shadow: 0 15px 50px -10px black;
    }

    p {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    button {
        min-width: 200px;
        border: none;
        background: #56c1ff;
        color: white;
        cursor: pointer;
    }

    .offlineLogo {
        width: 40px;
        filter: brightness(0.3);
        margin-left: 14px;
    }

</style>
